import validAddress from './validAddress';
import validNotPoBoxAddress from './validNotPoBoxAddress';

export const validShareAbleAddress = (value) => {
  return validAddress(value) ?? validNotPoBoxAddress(value);
};

export default validShareAbleAddress;
